const config = {
  SOCKET_URL: 'https://video-chat-production-0903.up.railway.app/',
};
export default config;
